import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './RegistrationfeeList.css';

const url = process.env.REACT_APP_BACKEND_URL;

const RegistrationfeeList = () => {
  const [registerfees, setRegisterfees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRegistrationfees = async () => {
      try {
        const response = await axios.get(`${url}/api/registerfee`);
        setRegisterfees(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch Registration fees');
      } finally {
        setLoading(false);
      }
    };

    fetchRegistrationfees();
  }, []);

  // const handleDelete = async (id) => {
  //   try {
  //     await axios.delete(`${url}/api/registerfee/${id}`);
  //     setRegisterfees(registerfees.filter(fee => fee._id !== id));
  //   } catch (err) {
  //     setError(err.response?.data?.message || 'Failed to delete Registration fee');
  //   }
  // };

  if (loading) return <div className="loading">Loading Registration Fees...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Registration Fee List</h2>
        <button
          onClick={() => navigate('/AddRegistrationfee')}
          className="add-button"
        >
          <Plus size={16} /> Add Registration Fee
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {registerfees.map(fee => (
            <tr key={fee._id}>
              <td>{fee.name}</td>
              <td>{fee.amount}</td>
              <td className="actions">

                <button
                  onClick={() => navigate(`/registerfee/edit/${fee._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>

                {/* <button 
        onClick={() => handleDelete(fee._id)}
        className="delete-btn"
      >
        <Trash2 size={14} />
      </button> */}
              </td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  );
};

export default RegistrationfeeList;
